import {BrickContext, ActionBrick, registerBrick, ErrorFlow} from 'olympe';
import * as PDFJS from 'pdfjs-dist';

export default class PDFToText extends ActionBrick {

    init(){
        PDFJS.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@4.7.76/build/pdf.worker.min.mjs`;
    }


    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {function()} forwardEvent
     * @param {function(string)} setText
     * @param {function(ErrorFlow)} setErrorFlow
     */
    async update($, [file], [forwardEvent, setText, setErrorFlow]) {
        try {
            const arrayBuffer = await file.getContentAsBinary();
            const text = await this.getData(arrayBuffer);

            setText(text);
            forwardEvent();
        } catch (e) {
            setErrorFlow(ErrorFlow.create(e.message, 510));
        }
    }

    async getData(dataBuffer) {
        let outputText = '';

        let doc = await PDFJS.getDocument(dataBuffer).promise;
        for (let i = 1; i <= doc.numPages; i++) {
            try {

                const pageData = await doc.getPage(i);
                const textContent = await pageData.getTextContent({
                    //replaces all occurrences of whitespace with standard spaces (0x20). The default value is `false`.
                    normalizeWhitespace: false,
                    //do not attempt to combine same line TextItem's. The default value is `false`.
                    disableCombineTextItems: false
                });

                let lastY, text = '';
                for (let item of textContent.items) {
                    if (lastY === item.transform[5] || !lastY){
                        text += item.str;
                    }
                    else{
                        text += '\n' + item.str;
                    }
                    lastY = item.transform[5];
                }

                outputText = `${outputText}\n\n${text}`;
            } catch (e) {
                console.error(e);
            }
        }
        doc.destroy();

        return outputText;
    }
}

registerBrick('0192b8a12750feb4a989', PDFToText);
